import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { getCsrfToken, getPusherKey } from '@mode/shared/util-js';
import { PusherEvent, SocketSubscription } from './socket.interface';
import Pusher, { Channel } from 'pusher-js';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private pusher: Pusher | undefined;
  private readonly pusherKey = getPusherKey(window.document);

  private initPusher() {
    if (this.pusherKey) {
      const csrfToken = getCsrfToken(window.document) ?? '';

      this.pusher = new Pusher(this.pusherKey, {
        cluster: 'mt1',
        auth: {
          headers: {
            'X-CSRF-Token': csrfToken,
          },
        },
      });
    }
  }

  public connect<T>(channelName: string): SocketSubscription<T> {
    if (!this.pusher) {
      this.initPusher();
    }

    const channel = this.pusher?.subscribe(channelName);
    const eventBus = new ReplaySubject<PusherEvent<T>>();
    const subscription: SocketSubscription<T> = {
      eventBus,
      disconnect: this.disconnect(channel),
    };

    channel?.bind_global((event: string, data: T) => {
      eventBus.next({ name: event, data, channel: channelName });
    });

    return subscription;
  }

  private disconnect(channel: Channel | undefined) {
    return () => {
      if (channel) {
        channel.unbind_all();
        this.pusher?.unsubscribe(channel.name);
      }
    };
  }
}
